import { Injectable } from '@angular/core';

import { JwtHelperService } from '@auth0/angular-jwt'; // npm i @auth0/angular-jwt

const jwt = new JwtHelperService();

@Injectable({
  providedIn: 'root',
})
export class JwtService {
  getToken(name: string): string {
    return window.localStorage[name];
  }
  saveToken(name: string, token: string) {
    window.localStorage[name] = token;
  }
  destroyToken(name: string) {
    window.localStorage.removeItem(name);
  }
  getId(name: string) {
    return jwt.decodeToken(this.getToken(name));
  }
}
